// extracted by mini-css-extract-plugin
export default {"card":"DesignCard_card__pXPZi"};